import { DetailedHTMLProps, HTMLAttributes } from "react";

type Props = DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> & {
  title: string;
  description: string;
};

const DefaultParagraph = ({
  title,
  description,
  className,
  ...props
}: Props) => {
  return (
    <section {...props} className={`p-1 bbg ${className}`}>
      <h5 className="small-title">{title}</h5>
      <p className="description">{description}</p>
    </section>
  );
};

export default DefaultParagraph;
